export function formatRequestId(settings, item) {
  const base = item.merchant_id ? `M${String(item.merchant_id).padStart(4, '0')}` : settings.acronym;

  return `${base}-${item.request_type[0].toUpperCase()}${item.id}`;
}
